export default "/images/the-telegraph.svg?bd8a1e1c961f94cd811483cb87912f5b";